export interface WebRoute {
  name:
    | "home"
    | "calendar"
    | "calls"
    | "customers"
    | "manage"
    | "appointment"
    | "customer";
  id?: string;
}

export function parseWebRoute(hash: string): WebRoute {
  const value = hash.replace(/^#\/?/, "");
  const [name, id] = value.split("/");
  if ((name === "appointment" || name === "customer" || name === "calls") && id) {
    return { name, id: decodeURIComponent(id) };
  }
  if (["home", "calendar", "calls", "customers", "manage"].includes(name)) {
    return { name: name as WebRoute["name"] };
  }
  return { name: "home" };
}
